import React from 'react';
import { Timer, CheckCircle } from 'lucide-react';

interface TokenExpirationModalProps {
  remainingSeconds: number;
  onStayLoggedIn: () => void;
}

const TokenExpirationModal: React.FC<TokenExpirationModalProps> = ({
  remainingSeconds,
  onStayLoggedIn,
}) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const isUrgent = remainingSeconds <= 60;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <span style={iconStyle}><Timer size={40} /></span>
          <h3 style={titleStyle}>Sitzung läuft ab</h3>
        </div>

        <div style={contentStyle}>
          <p style={messageStyle}>
            Ihre Sitzung läuft in Kürze ab. Klicken Sie auf den Button, um angemeldet zu bleiben.
          </p>

          <div style={{
            ...countdownStyle,
            color: isUrgent ? '#dc3545' : '#495057',
            borderColor: isUrgent ? '#dc3545' : '#dee2e6',
          }}>
            {timeDisplay}
          </div>
        </div>

        <div style={buttonContainerStyle}>
          <button
            onClick={onStayLoggedIn}
            style={stayButtonStyle}
          >
            <CheckCircle size={16} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 6 }} /> Ich bin noch hier
          </button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  backdropFilter: 'blur(4px)',
};

const modalStyle: React.CSSProperties = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '0',
  width: '90%',
  maxWidth: '420px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  overflow: 'hidden',
};

const headerStyle: React.CSSProperties = {
  padding: '1.5rem 1.5rem 1rem',
  textAlign: 'center',
};

const iconStyle: React.CSSProperties = {
  fontSize: '3rem',
  display: 'block',
  marginBottom: '0.75rem',
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontSize: '1.35rem',
  fontWeight: 600,
  color: '#1f2937',
};

const contentStyle: React.CSSProperties = {
  padding: '0 1.5rem 1.5rem',
  textAlign: 'center',
};

const messageStyle: React.CSSProperties = {
  color: '#6b7280',
  lineHeight: 1.6,
  margin: '0 0 1.25rem',
  fontSize: '0.95rem',
};

const countdownStyle: React.CSSProperties = {
  fontSize: '2.5rem',
  fontWeight: 700,
  fontFamily: 'monospace',
  padding: '0.75rem',
  border: '2px solid #dee2e6',
  borderRadius: '8px',
  display: 'inline-block',
  minWidth: '120px',
  transition: 'color 0.3s, border-color 0.3s',
};

const buttonContainerStyle: React.CSSProperties = {
  padding: '0 1.5rem 1.5rem',
  textAlign: 'center',
};

const stayButtonStyle: React.CSSProperties = {
  padding: '0.75rem 2rem',
  fontSize: '1.05rem',
  fontWeight: 600,
  color: 'white',
  backgroundColor: '#198754',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  width: '100%',
  transition: 'background-color 0.2s',
};

export default TokenExpirationModal;

